import DynamicDropdown from "../../../Components/Dropdown/DynamicDropdown";
import { getStepInstruments } from "../../../Requests/stepRequests";
import {
  IPairPositionSearchParams,
  PositionType,
} from "../../../Interfaces/optionDomain";
import {
  getGroups,
  getRemainingOptionId,
} from "../../../Requests/optionDomain";
import { DropdownItem } from "../../../Interfaces/dropdownInterfaces";
import CheckBox from "../../../Components/Checkbox";
import { getBaseInstruments } from "../../../Requests/Order/tradeTableRequests";
import TextInput from "../../../Components/TextInput";
import Button from "../../../Components/Button";
import DynamicMultiSelectDropdown from "../../../Components/Dropdown/DynamicMultiSelectDropdown";
import { StaticMultiSelectDropdown } from "../../../Components/Dropdown/StaticMultiSelectDropdown";

interface IProps {
  searchParamChangeHandler: (name: string, value: any) => void;
  searchParam: IPairPositionSearchParams;
  onSubmit?: () => void;
  isDtm?: boolean;
}

const PairPositionSearchParamUI = ({
  searchParam,
  searchParamChangeHandler,
  onSubmit,
  isDtm,
}: IProps) => {
  const positionTypeOptions: DropdownItem[] = [
    { id: PositionType.CS, name: "CS" },
    { id: PositionType.LS, name: "LS" },
    { id: PositionType.PS, name: "PS" },
    { id: PositionType.SS, name: "SS" },
    { id: PositionType.CC, name: "CC" },
    { id: PositionType.PP, name: "PP" },
    { id: PositionType.RCC, name: "RCC" },
  ];

  return (
    <div className="border border-gray-300 rounded p-3 grid grid-cols-2 gap-3 !w-[330px] !min-w-[330px]">
      {!isDtm ? (
        <DynamicMultiSelectDropdown
          dropdown={{
            name: "groupId",
            placeholder: "گروه",
            extraLabel: true,
          }}
          getData={getGroups}
          onChange={searchParamChangeHandler}
          value={searchParam.groupId}
        />
      ) : (
        <></>
      )}
      <StaticMultiSelectDropdown
        name="positionType"
        label="نوع پوزیشن"
        extraLabel
        items={positionTypeOptions}
        withSelectAll
        onChange={searchParamChangeHandler}
        value={searchParam.positionType}
      />
      <DynamicDropdown
        dropdown={{
          name: "remainingOptionId",
          placeholder: "مقایسه روز تا سررسید",
          extraLabel: true,
        }}
        getData={getRemainingOptionId}
        onChange={searchParamChangeHandler}
        value={searchParam.remainingOptionId}
      />
      <CheckBox
        checked={searchParam.sameStrikePrice}
        label="قیمت اعمال یکسان"
        name="sameStrikePrice"
        onChange={searchParamChangeHandler}
      />
      {!isDtm ? <div /> : <></>}
      <CheckBox
        checked={searchParam.sameKind}
        label="الزام به هم جنس بودن"
        name="sameKind"
        onChange={searchParamChangeHandler}
      />
      {/* <CheckBox
        checked={searchParam.sameDueDate}
        label="الزام به هم رسید بودن"
        name="sameDueDate"
        onChange={searchParamChangeHandler}
      /> */}
      {!isDtm ? (
        <>
          <DynamicDropdown
            dropdown={{
              name: "ins1",
              placeholder: "نماد 1",
              extraLabel: true,
            }}
            getData={getStepInstruments}
            onChange={searchParamChangeHandler}
            value={searchParam.ins1}
          />
          <DynamicDropdown
            dropdown={{
              name: "ins2",
              placeholder: "نماد 2",
              extraLabel: true,
            }}
            getData={getStepInstruments}
            onChange={searchParamChangeHandler}
            value={searchParam.ins2}
          />
        </>
      ) : (
        <></>
      )}
      <DynamicDropdown
        dropdown={{
          name: "baseIns1",
          placeholder: "نماد پایه 1",
          extraLabel: true,
        }}
        getData={() => getBaseInstruments()}
        onChange={searchParamChangeHandler}
        value={searchParam.baseIns1}
      />
      <DynamicDropdown
        dropdown={{
          name: "baseIns2",
          placeholder: "نماد پایه 2",
          extraLabel: true,
        }}
        getData={() => getBaseInstruments()}
        onChange={searchParamChangeHandler}
        value={searchParam.baseIns2}
      />
      {!isDtm ? (
        <>
          <TextInput
            label={"حداقل % بازده روزانه"}
            onChange={searchParamChangeHandler}
            name="minProfitLock"
            value={searchParam.minProfitLock?.toString()}
            extraLabel
            kind="negativeDecimalNumbers"
          />
          <TextInput
            label="حداکثر % بازده روزانه"
            onChange={searchParamChangeHandler}
            name="maxProfitLock"
            value={searchParam.maxProfitLock?.toString()}
            extraLabel
            kind="negativeDecimalNumbers"
          />
        </>
      ) : (
        <>
          <TextInput
            label="حداقل قیمت 1"
            onChange={searchParamChangeHandler}
            name="side1MinPrice"
            value={searchParam.side1MinPrice?.toString()}
            extraLabel
            kind="negativeDecimalNumbers"
          />
          <TextInput
            label="حداقل درصد از پایه 1"
            onChange={searchParamChangeHandler}
            name="side1MinBasePricePercentage"
            value={searchParam.side1MinBasePricePercentage?.toString()}
            extraLabel
            kind="negativeDecimalNumbers"
          />

          <TextInput
            label="حداقل قیمت 2"
            onChange={searchParamChangeHandler}
            name="side2MinPrice"
            value={searchParam.side2MinPrice?.toString()}
            extraLabel
            kind="negativeDecimalNumbers"
          />

          <TextInput
            label="حداقل درصد از پایه 2"
            onChange={searchParamChangeHandler}
            name="side2MinBasePricePercentage"
            value={searchParam.side2MinBasePricePercentage?.toString()}
            extraLabel
            kind="negativeDecimalNumbers"
          />

          <TextInput
            label="حداقل گاما"
            onChange={searchParamChangeHandler}
            name="minGamma"
            value={searchParam.minGamma?.toString()}
            extraLabel
            kind="negativeDecimalNumbers"
          />
          <TextInput
            label="حداکثر گاما"
            onChange={searchParamChangeHandler}
            name="maxGamma"
            value={searchParam.maxGamma?.toString()}
            extraLabel
            kind="negativeDecimalNumbers"
          />
        </>
      )}
      <TextInput
        label="حداقل حجم روز قبل"
        onChange={searchParamChangeHandler}
        name="minLastDayTradeVolume"
        value={searchParam.minLastDayTradeVolume?.toString()}
        extraLabel
        kind="price"
      />
      <TextInput
        label="حداقل ارزش روز قبل"
        onChange={searchParamChangeHandler}
        name="minLastDayTradeValue"
        value={searchParam.minLastDayTradeValue?.toString()}
        extraLabel
        kind="price"
      />
      <div />
      <TextInput
        label="حداکثر ٪ ریهج"
        onChange={searchParamChangeHandler}
        name="maxReHedgeRatio"
        value={searchParam.maxReHedgeRatio?.toString()}
        extraLabel
        kind="negativeDecimalNumbers"
      />
      <TextInput
        label={isDtm ? "حداقل DTM 1" : "حداقل روز تا سررسید(اول)"}
        onChange={searchParamChangeHandler}
        name="lessMinRemainingDay"
        value={searchParam.lessMinRemainingDay?.toString()}
        extraLabel
        kind="negativeDecimalNumbers"
      />
      <TextInput
        label={isDtm ? "حداکثر DTM 1" : "حداکثر روز تا سررسید(اول)"}
        onChange={searchParamChangeHandler}
        name="lessMaxRemainingDay"
        value={searchParam.lessMaxRemainingDay?.toString()}
        extraLabel
        kind="negativeDecimalNumbers"
      />
      <TextInput
        label={isDtm ? "حداقل DTM 2" : "حداقل روز تا سررسید(دوم)"}
        onChange={searchParamChangeHandler}
        name="moreMinRemainingDay"
        value={searchParam.moreMinRemainingDay?.toString()}
        extraLabel
        kind="negativeDecimalNumbers"
      />
      <TextInput
        label={isDtm ? "حداکثر DTM 2" : "حداکثر روز تا سررسید(دوم)"}
        onChange={searchParamChangeHandler}
        name="moreMaxRemainingDay"
        value={searchParam.moreMaxRemainingDay?.toString()}
        extraLabel
        kind="negativeDecimalNumbers"
      />
      <TextInput
        label="حداقل ضریب هج"
        onChange={searchParamChangeHandler}
        name="minHedgeFactor"
        value={searchParam.minHedgeFactor?.toString()}
        extraLabel
        kind="negativeDecimalNumbers"
      />
      <TextInput
        label="حداکثر ضریب هج"
        onChange={searchParamChangeHandler}
        name="maxHedgeFactor"
        value={searchParam.maxHedgeFactor?.toString()}
        extraLabel
        kind="negativeDecimalNumbers"
      />
      <div />
      {onSubmit ? (
        <Button onClick={onSubmit} text="جستجو" variant="contained" />
      ) : (
        <></>
      )}
    </div>
  );
};

export default PairPositionSearchParamUI;
